/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/recurring_medium'
export default icon
